import { Button, Typography } from "@mui/material";

import "./EmptyState.css";

export function EmptyState({ onBrowse }: { onBrowse: () => void }) {
  return (
    <div className="empty-state">
      <Typography variant="h5">Drop a model here</Typography>
      <Typography color="text.secondary">A .glb or .gltf</Typography>
      <Button variant="contained" onClick={onBrowse} data-testid="viewer-browse">
        Choose a file
      </Button>
    </div>
  );
}
